/** FormTTN **/
export const uploadImgs = [
  { field: 'imgUrlFront', title: 'Лицевая ТТН', formField: 'fileFront' },
  { field: 'imgUrlBack', title: 'Оборотная ТТН', formField: 'fileBack' },
  { field: 'imgUrlFrontTn', title: 'Лицевая ТН', formField: 'fileFrontTn' },
  { field: 'imgUrlBackTn', title: 'Оборотная ТН', formField: 'fileBackTn' },
]

export const getRules = (checkTTN, checkFact) => ({
  number: { required: true, message: 'Заполните № ТТН', trigger: 'blur' },
  date: { required: true, message: 'Укажите дату', trigger: 'blur' },
  date_loaded: { required: true, message: 'Укажите дату', trigger: 'blur' },
  date_unloaded: { required: true, message: 'Укажите дату', trigger: 'blur' },
  type_code: {
    required: true,
    message: 'Укажите тип перевозки',
    trigger: 'blur',
  },
  brutto_ttn: { validator: checkTTN, trigger: ['blur', 'change'] },
  netto_ttn: { validator: checkTTN, trigger: ['blur', 'change'] },
  brutto_fact: { validator: checkFact, trigger: ['blur', 'change'] },
  netto_fact: { validator: checkFact, trigger: ['blur', 'change'] },
})

export const NO_PAPER_STATUSES = {
  new: 'Черновик',
  nopaperPrepareFiles: 'Подготовка файлов к подписанию',
  nopaperPreview: 'Ожидает подписи отправителя',
  nopaperPreviewBeforeOferta: 'Ожидает подписи отправителя',
  nopaperOfertaSenderPreview: 'Ожидает подписи отправителя',
  nopaperSenderSign: 'Подпись отправителя',
  nopaperReceiverSign: 'Ожидает подписи получателя',
  nopaperReceiverPreview: 'Ожидает подписи получателя',
  nopaperReceiverPreviewBeforeOferta: 'Ожидает подписи получателя',
  nopaperOfertaReceiverPreview: 'Ожидает подписи получателя',
  nopaperReceiverSigning: 'Подпись получателя',
  nopaperSignRefused: 'Пакет документов был отклонен получателем',
  nopaperProcessSign: 'Идет подписание получателем',
  nopaperEnd: 'Документы подписаны',
}
